import $ from 'jquery';

$(window).scroll(function(){
    var scrollPos = $(document).scrollTop();
    
    if (scrollPos > 420) {
        $('header').addClass('header-bg');
    }
    else {
        $('header').removeClass('header-bg');
    }
});


// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/header.js